(function () {
  function getProductForms() {
    return document.querySelectorAll('product-form.product-form');
  }

  function getVariantSelector() {
    return document.querySelector('select.product-variant-selector');
  }

  function variantOptionIsAvailable(option) {
    return option && option.getAttribute('data-available') === 'true';
  }

  function updateBuyBoxForVariant(option) {
    if (!option || !option.value) return;

    const isAvailable = variantOptionIsAvailable(option);
    const price = option.dataset.price || '';
    const variantId = option.value;

    document.querySelectorAll('.product-form input.product-variant-id').forEach(function (input) {
      input.value = variantId;
      input.setAttribute('value', variantId);
      input.disabled = !isAvailable;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelectorAll('.product-form__submit .variant-price').forEach(function (priceEl) {
      if (price) priceEl.textContent = price;
    });

    document.querySelectorAll('.buy-button-wrapper').forEach(function (wrapper) {
      wrapper.classList.remove('size-selector-active');
    });

    document.querySelectorAll('#product-variant-selector').forEach(function (wrapper) {
      wrapper.classList.remove('size-selector-active');
      wrapper.classList.remove('size-selector-error');
    });

    getProductForms().forEach(function (productForm) {
      const submitButton = productForm.querySelector('.product-form__submit[name="add"]');
      const bisButton = productForm.querySelector('.bis-trigger');
      const productId = productForm.dataset.productId;
      const shippingText = productForm.dataset.shippingText || '';
      const comingSoonText = productForm.dataset.comingSoonText || '';
      const isPreorder = productForm.dataset.preorderProduct === 'true';
      const preorderShippingText = productForm.dataset.preorderShippingText || 'Ships in 2-3 weeks';
      const inventoryDot = productForm.querySelector('[data-inventory-dot]');
      const inventoryLabel = productForm.querySelector('[data-inventory-label]');
      const shippingStatus = productForm.querySelector('[data-shipping-status]');

      if (submitButton) {
        submitButton.classList.toggle('hidden', !isAvailable);
        submitButton.toggleAttribute('disabled', !isAvailable);
        submitButton.removeAttribute('aria-disabled');
      }

      if (bisButton) {
        bisButton.classList.toggle('hidden', isAvailable);
        if (productId) {
          bisButton.dataset.bisTriggerTarget = 'bis-container-' + productId + '-' + variantId;
        }
      }

      if (inventoryDot) {
        inventoryDot.style.background = isAvailable ? '#00A849' : 'red';
      }

      if (inventoryLabel) {
        inventoryLabel.textContent = isAvailable
          ? isPreorder
            ? 'Available on pre-orders'
            : 'In Stock'
          : 'Out of Stock';
      }

      if (shippingStatus) {
        shippingStatus.textContent = isAvailable
          ? isPreorder
            ? preorderShippingText
            : shippingText
          : comingSoonText;
      }
    });

    const bisContainer = document.querySelector('.bis-container');
    const productForm = getProductForms()[0];
    if (bisContainer && productForm) {
      const productId = productForm.dataset.productId;
      if (productId) {
        bisContainer.id = 'bis-container-' + productId + '-' + variantId;
        bisContainer.dataset.variantId = variantId;
      }
    }
  }

  function highlightVariantSelector() {
    const selector = getVariantSelector();
    const wrapper = document.getElementById('product-variant-selector');
    if (!selector || !wrapper) return;

    wrapper.classList.toggle('size-selector-error', !selector.value);
  }

  function initVariantSelector() {
    const selector = getVariantSelector();
    if (!selector) return;

    selector.addEventListener('change', function (event) {
      updateBuyBoxForVariant(event.target.selectedOptions[0]);
    });

    document.querySelectorAll('.size-selector-button').forEach(function (button) {
      button.addEventListener('click', highlightVariantSelector);
    });

    document.addEventListener('click', function (event) {
      const bisButton = event.target.closest('.bis-trigger');
      if (!bisButton || bisButton.classList.contains('hidden')) return;

      const modal = document.getElementById('bis-modal');
      if (!modal) return;

      event.preventDefault();
      modal.style.display = 'flex';
      modal.setAttribute('aria-hidden', 'false');
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-bis-close="true"], #bis-close, .bis-close')) {
        const modal = document.getElementById('bis-modal');
        if (!modal) return;
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      }
    });

    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) {
      const urlOption = selector.querySelector('option[value="' + urlVariantId + '"]');
      if (urlOption) {
        urlOption.selected = true;
        updateBuyBoxForVariant(urlOption);
        return;
      }
    }

    if (selector.selectedOptions[0]?.value) {
      updateBuyBoxForVariant(selector.selectedOptions[0]);
    }
  }

  function initStickyAddToCartVisibility() {
    const stickyBar = document.querySelector('.product-sticky-add-to-cart-btn');
    const mainBuyButtonWrapper = document.querySelector('.product__info-container .buy-button-wrapper');
    if (!stickyBar || !mainBuyButtonWrapper) return;

    const mobileMedia = window.matchMedia('(max-width: 749px)');
    let animationFrameId = null;

    function updateStickyBar() {
      const buyButtonRect = mainBuyButtonWrapper.getBoundingClientRect();
      const mainBuyButtonIsVisible = buyButtonRect.bottom > 0 && buyButtonRect.top < window.innerHeight;
      const shouldShow = mobileMedia.matches && !mainBuyButtonIsVisible;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      stickyBar.toggleAttribute('inert', !shouldShow);
    }

    function requestStickyBarUpdate() {
      if (animationFrameId !== null) return;

      animationFrameId = window.requestAnimationFrame(function () {
        updateStickyBar();
        animationFrameId = null;
      });
    }

    stickyBar.setAttribute('aria-hidden', 'true');
    stickyBar.setAttribute('inert', '');
    updateStickyBar();
    window.addEventListener('scroll', requestStickyBarUpdate, { passive: true });
    window.addEventListener('resize', requestStickyBarUpdate);
    mobileMedia.addEventListener('change', requestStickyBarUpdate);
  }

  function initProductPage() {
    initVariantSelector();
    initStickyAddToCartVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
